import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function ContactCtaSection() {
  return (
    <section className="w-full bg-secondary-50 border-t border-secondary-200 py-14 md:py-16">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.3em] uppercase text-secondary-700 mb-3">
              <span className="block w-6 h-px bg-secondary-500"></span>
              Get In Touch
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-secondary-950 leading-snug">
              有线索想提供，或者想和我们聊聊你的遭遇
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-secondary-900/80">
              我们接受读者投稿与线索，也愿意就内容合作、心理与法律资源对接提供力所能及的帮助。所有来信我们都会看，只是回复可能需要一点时间。
            </p>
            <p className="mt-4 text-xs md:text-sm text-secondary-800/80">{siteInfo.replyNote}</p>
          </div>

          <div className="shrink-0 w-full lg:w-auto">
            <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-primary-500 text-background-50 hover:bg-primary-600"
              >
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                前往联系页面
              </Link>
              <a
                href={`mailto:${siteInfo.tipEmail}`}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-background-50 border border-secondary-300 text-secondary-900 hover:border-secondary-500"
              >
                <i className="ri-lightbulb-line" aria-hidden="true"></i>
                {siteInfo.tipEmail}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}